import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { colors, gradients } from '@theme/colors';
import { LogoManta } from '@components/brand';
import { Badge } from '@components/ui';
import { PROJECT } from '@lib/constants';
import { Menu, X } from 'lucide-react';

interface HeaderProps {
  onMenuToggle?: () => void;
  isMenuOpen?: boolean;
}

export function Header({ onMenuToggle, isMenuOpen }: HeaderProps) {
  const location = useLocation();

  return (
    <header
      style={{
        background: gradients.header,
        color: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >
      <div
        style={{
          maxWidth: 1600,
          margin: '0 auto',
          padding: '12px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {onMenuToggle && (
            <button
              onClick={onMenuToggle}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                borderRadius: 8,
                padding: 8,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
              }}
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          )}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <LogoManta width={100} height={32} />
          </Link>
          <div
            style={{
              height: 24,
              width: 1,
              background: 'rgba(255,255,255,0.3)',
              margin: '0 8px',
            }}
          />
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: '1rem',
                fontWeight: 600,
                color: 'white',
              }}
            >
              {PROJECT.name}
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: '0.75rem',
                opacity: 0.8,
              }}
            >
              {PROJECT.contract} | {PROJECT.client}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Badge variant="primary">{PROJECT.location}</Badge>
          <div
            style={{
              background: 'rgba(255,255,255,0.15)',
              padding: '6px 12px',
              borderRadius: 20,
              fontSize: '0.75rem',
            }}
          >
            v1.0.0
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
